<template>
  <div class="users-list">
    <TotalInfoBlock v-if="paginationData?.total" :total="parseInt(paginationData?.total)" />
    <template v-if="isMobileDevice">
      <div v-if="items.length">
        <CustomersCard
          v-for="item of items"
          :id="item.id"
          :key="item.id"
          :status="item.status"
          :user="item.user"
          :company="item.company"
          :tax-number="item.taxNumber"
          :level="item.bonusProgramLevel"
          @clickOnOrder="onClickRow({ id: item.id })"
        />
      </div>
      <SkeletonLoaderCard v-else :table-headers="tableHeaders" />
    </template>

    <OurTable
      v-else
      :headers="tableHeaders"
      :items="items"
      :table-fixed="false"
      class="users-list-table"
      @clickRow="onClickRow"
    >
      <template #cell-company="{ value }">
        <div class="company-block">
          <div class="text">{{ value }}</div>
        </div>
      </template>

      <template #cell-customer="{ value }">
        <div class="company-block">
          <div class="text">{{ value ? value?.name : "–" }}</div>
        </div>
      </template>

      <template #cell-taxNumber="{ value }">
        <div class="company-block">
          <div class="text">{{ value ? value : "–" }}</div>
        </div>
      </template>

      <template #cell-status="{ value }">
        <OurTag size="md" :text="value?.text" :color="value?.color" />
      </template>
    </OurTable>

    <OurPagination
      v-if="isMoreThanOnePage"
      :current-page="paginationData.currentPage"
      :per-page="paginationData.perPage"
      :total="paginationData.total"
      :disabled="isLoading"
      @pageChange="onPageChange"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CustomersCard from "@/components/MobileCards/CustomersCard.vue";
import SkeletonLoaderCard from "@/ui/loader/SkeletonLoaderCard.vue";
import TotalInfoBlock from "@/components/TotalInfoBlock.vue";
export default {
  name: "CompanyList",
  components: { CustomersCard, SkeletonLoaderCard, TotalInfoBlock },

  props: {
    items: {
      type: Array,
      default: () => [],
    },

    paginationData: {
      type: Object,
      default: () => {},
    },

    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters("breakpoint", ["isMobileDevice"]),
    tableHeaders() {
      const data = [
        {
          value: "id",
          text: this.$t("page.users.id"),
          thClass: "w-24",
          tdClass: "max-w-[2rem] min-w-[5rem]",
        },
        {
          value: "company",
          text: this.$t("page.dealersCompany.company"),
          thClass: "w-[10rem]",
          tdClass: "max-w-[12rem] min-w-[10rem]",
        },
        {
          value: "user",
          text: this.$t("page.dealersCompany.user"),
          thClass: "w-[5rem]",
          tdClass: "max-w-[10rem] min-w-[10rem]",
        },
        {
          value: "customer",
          text: this.$t("page.dealersCompany.customer"),
          thClass: "w-[10rem]",
          tdClass: "max-w-[12rem] min-w-[10rem]",
        },
        {
          value: "taxNumber",
          text: this.$t("page.dealersCompany.taxNumber"),
          thClass: "w-[8rem]",
          tdClass: "max-w-[10rem] min-w-[8rem]",
        },
        {
          value: "bonusProgramLevel",
          text: this.$t("page.customers.bonusProgramLevel"),
          thClass: "w-[7rem]",
          tdClass: "max-w-[9rem] min-w-[7rem] capitalize",
        },
        {
          value: "status",
          text: this.$t("page.dealersCompany.status"),
          thClass: "w-[7rem]",
          tdClass: "max-w-[9rem] min-w-[7rem]",
        },
      ];

      return data;
    },

    isMoreThanOnePage() {
      return this.paginationData.lastPage > 1;
    },

    routePage() {
      return Number.parseInt(this.$route.query.page, 10) || 1;
    },
  },

  watch: {
    routePage(newPage) {
      if (newPage !== this.paginationData.currentPage) {
        this.$emit("pageChange", newPage);
      }
    },
  },

  methods: {
    onPageChange(page) {
      this.$emit("pageChange", page);

      if (page !== this.routePage) {
        const query = { ...this.$route.query };

        delete query.page;

        const nextQuery = page === 1 ? query : { ...query, page };

        this.$router.push({ name: this.$route.name, query: nextQuery });
      }
    },

    onClickRow(row) {
      this.$emit("onClickRow", row.id);
    },
  },
};
</script>

<style lang="postcss" scoped>
.users-list {
  .contacts-block,
  .company-block {
    @apply overflow-hidden;

    .email,
    .text {
      @apply truncate;
    }
  }
}
</style>
